import "GIS/Map/Layer/Vector";
import "GIS/Map/Layer/OL3/WFS";
import "GIS/Format";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 * @extends GIS.Map.Layer.Vector
 */
GIS.Map.Layer.WFS = Class(GIS.Map.Layer.Vector, /** @lends GIS.Map.Layer.WFS.prototype */ {
    vendors: {
        "ol3": GIS.Map.Layer.OL3.WFS
    },
    // options
    format: GIS.Format.GML3,
    params: {
        version: "2.0.0",
        typeName: null,
        filter: null,
        maxFeatures: null,
        propertyName: null,
        outputFormat: GIS.Format.GML3
    },
    /** @inheritDoc */
    optionsNames()
    {
        return this.ParentCall().concat(["params"]);
    },
    /**
     * @param {Object} options
     * @protected
     */
    prepareOptions(options)
    {
        options = this.Parent(options);

        if (options.format != null) {
            _.set(options, "params.outputFormat", options.format);
        }

        return options;
    },
    /**
     * @returns {Promise}
     */
    GetCapabilities()
    {
        return this.layer.GetCapabilities();
    },
    /**
     * @returns {string}
     */
    getGetCapabilitiesURL()
    {
        return this.layer.getGetCapabilitiesURL();
    },
    /**
     * Executes GetFeature request
     * @param {number[]} extent
     * @param {string} projection
     * @param {Object} [options] Additional request options.
     * @returns {Promise}
     */
    GetFeature(extent, projection, options)
    {
        return this.layer.GetFeature(extent, projection, options);
    },
    /**
     * @returns {string}
     */
    getGetFeatureURL()
    {
        return this.layer.getGetFeatureURL();
    }
});
